import { Injectable, NgZone, EventEmitter } from '@angular/core';
import { YT } from '../../youtube-player/models/youtube';

const /** @type {?} */ $window: any = window;
const /** @type {?} */ iFrameSrc = 'http://www.youtube.com/iframe_api';
export class YoutubePlayerService {
/**
 * @param {?} zone
 */
constructor(private zone: NgZone) { }
/**
 * @param {?} domElementId
 * @param {?} playerOptions
 * @param {?} readyEvent
 * @param {?} stateChangeEvent
 * @return {?}
 */
createPlayer(domElementId: string, playerOptions: YT.PlayerOptions,
    readyEvent: EventEmitter<YT.Player>, stateChangeEvent: EventEmitter<YT.PlayerState>) {
    return setInterval(() => {
      if ((typeof $window.YT !== 'undefined') && $window.YT && $window.YT.Player) {
        const /** @type {?} */ player = new $window.YT.Player(domElementId, {
          ...playerOptions,
          events: {
            onReady: (ev: YT.PlayerEvent) => {
              this.zone.run(() =>
                readyEvent.emit(ev.target));
            },
            onStateChange: (ev: YT.OnStateChangeEvent) => {
              /**
               * player state is 1 (playing), 2 for Pause. Reference https://developers.google.com/youtube/iframe_api_reference
               */
              this.zone.run(() => stateChangeEvent.emit(ev.data));
            }
          }
        });
      }
    }, 100);
  }
/**
 * @return {?}
 */
loadPlayerApi(): void {
    const /** @type {?} */ doc = $window.document;
    const /** @type {?} */ playerApi = doc.createElement('script');
    playerApi.type = 'text/javascript';
    playerApi.src = iFrameSrc;
    doc.body.appendChild(playerApi);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
];
}

function YoutubePlayerService_tsickle_Closure_declarations() {
/** @type {?} */
YoutubePlayerService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YoutubePlayerService.ctorParameters;
/** @type {?} */
YoutubePlayerService.prototype.zone;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
